module.exports = __webpack_public_path__ + "img/kj4.abd4a73a.png";